import React, { useEffect, useState, useCallback, useRef } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { apiHelper } from "../../lib/ApiHelper";
import "../MainBox.css";
import _ from 'lodash';
import CurrencyInput from 'react-currency-input-field';
import GeneralWarningPopUp from "../../WarningPopUp/GenralWarningPopUp";
import PRHLoader from "../../lib/PRHLoader";
import { AgGridReact } from "@ag-grid-community/react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import "@ag-grid-community/styles/ag-theme-balham.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { RangeSelectionModule } from "@ag-grid-enterprise/range-selection";
import { ModuleRegistry } from "@ag-grid-community/core";
ModuleRegistry.registerModules([
    ClientSideRowModelModule,
    RangeSelectionModule,
]);
import { LicenseManager } from "@ag-grid-enterprise/core";


LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-058820}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Penguin_Random_House_LLC}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{InventoryHub}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{InventoryHub}_need_to_be_licensed___{InventoryHub}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{4_April_2025}____[v3]_[01]_MTc0MzcyMTIwMDAwMA==a87b1efc2ee2da35884b94c846d80314");
export default function SpecForm(props) {
    const gridApi = useRef(null);
    const [activeAltRates, setActiveAltRates] = useState(true);
    const [calCData, setCalCData] = useState({ coverPrice: 0, units: 0, unitCost: 0, discount: 0, returns: 0, royalty: 0 });
    const [marginData, setMarginData] = useState(null);
    const [activeMarginRates, setActiveMarginRates] = useState(true);
    const [defaultMargin, setDefaultMargin] = useState(null);
    const [marginRates, setMarginRates] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [isMArginLoading, setIsMarginLoading] = useState(false);
    const [isCostLoading, setIsCostLoading] = useState(false);
    const updatemargin = useRef(null);
    const title = "Reset to default";
    const option1 = "Reset";
    const option2 = "Cancel";
    const warning = "This will reset Alt Rates and Margin Rates value to Defaults";
    const [showWarning, setShowWarning] = useState(false);
    const gridOptions = {
        defaultColDef: {
            resizable: true,
            filter: true,
            sortable: true
        },
        accentedSort: true,
        suppressRowClickSelection: true,
        suppressDragLeaveHidesColumns: true, // ✅ stops column from being dragged away (out of the grid)
        suppressColumnMoveAnimation: false,  // optional: shows animation when interchanging
        onFirstDataRendered: (params) => {
            params.api.autoSizeColumns(['printer']);
            //     params.api.sizeColumnsToFit(['printer']);
        }
    }



    /* const columnDefMarginRates = [
         {
             headerName: "Print Quantity",
             width: 100,
             valueFormatter: params => params.value ? params.value.toLocaleString() : '',
 
         },
         {
             headerName: "Unit Cost",
             width: 80,
             valueFormatter: params => params.value ? `$${params.value.toFixed(3)}` : '',
         },
         {
             headerName: "Printer",
             width: 200
         },
         {
             headerName: "Alt Margin",
             width: 90,
             valueFormatter: params => params.value ? `${(params.value * 100).toFixed(2)}%` : '',
         },
         {
             headerName: "Country",
             width: 80,
         },
         {
             headerName: "Freight Lead Time",
             width: 120,
         },
         {
             headerName: '',
             width: 50
         }
     ];*/
    const columnDefMarginRates = [

        {
            headerName: "Print Quantity",
            field: "printQty",
            headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-right",
            width: 90,
            valueFormatter: params => params.value ? params.value.toLocaleString() : '',
            sortable: false
        },
        {
            headerName: "Unit Cost",
            field: "unitCost",
            headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource cell-text-right",
            width: 80,
            valueFormatter: params => params.value ? `$${params.value.toFixed(3)}` : '',
            sortable: false
        },
        {
            headerName: "Printer",
            field: "printer",
            headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left",
            resizable: true,
            sortable: false
        },
        {
            headerName: "Alt Margin",
            field: "altMargin",
            headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-right",
            width: 70,
            valueFormatter: params => params.value ? `${(params.value * 100).toFixed(2)}%` : '',
            sortable: false
        },
        {
            headerName: "Country",
            field: "country",
            headerClass: "HeaderClassSource",
            cellClass: "CellClassSource leftAlign",
            width: 60,
            sortable: false
        },
        {
            headerName: "Freight Lead Time",
            field: "freightLeadTime",
            headerClass: "HeaderClassSource",
            cellClass: "CellClassSource leftAlign",
            width: 120,
            sortable: false
        }
    ];

    const columnDefsDK = [
        {
            headerName: "Prod Order", field: "productionOrder", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource cell-text-right", width: 70, sort: 'desc'
        },

        {
            headerName: "Req Delivery", field: "reqDelivery", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource cell-text-right", cellRenderer: (params) => {
                if ((params.value == '0001-01-01T00:00:00')) { return <span></span>; }
                return <span>{showFormatDate(params.value)}</span>;

            }, width: 90
        },
        {
            headerName: "Batch", field: "batch", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 80
        },
        {
            headerName: "Ordered Qty", field: "orderQuantity", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource  cell-text-right", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, width: 80,
        },

        {
            headerName: "Receipt Date", field: "receiptDate", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource cell-text-right", cellRenderer: (params) => {
                if ((params.value == '0001-01-01T00:00:00')) { return <span></span>; }
                return <span>{showFormatDate(params.value)}</span>;

            }, width: 90
        },
        {
            headerName: "Receipt Qty", field: "receiptQty", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource  cell-text-right", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, width: 80,
        },

    ]

    const sendNotes = async (data) => {
        try {

            if (data) {
                titleAlert("Sending to Notes... ", "update", 'margin-update');
                const note = `${getFormatCurrentDate()} Alt Margin ${(data?.altMargin * 100).toFixed(2)}%:${data?.printQty}, $${(data?.unitCost).toFixed(3)}/unit, printer ${data?.printer} , Royalty ${(defaultMargin?.royaltyRate)}%, Discount ${(defaultMargin?.discount)}%, Returns ${(defaultMargin?.returnsRate)}%, Price ${defaultMargin?.coverPrice}`;
                const payload = {
                    noteID: 0,
                    isbn: data.isbn,
                    status: "Active", isPriority: false, visibility: "Public", note: note, creator: props.upn, Action: 'I'
                }
                const res = await apiHelper.inventoryPostCall("createNotes", payload, true);
                props.setOnChangeNote();
                titleAlert("Note saved successfully", "success", 'margin-update');
            }
        } catch (error) {
            console.error("add note  failed");
            titleAlert("Add to Note Failed.", "error", 'margin-update');
        } finally {
            setTimeout(() => titleAlert('', 'info', 'margin-update'), 2000);
        }
    }

    function formatNumberWithCommas(number) {
        if (isNaN(number)) {
            return '';
        }
        // Convert number to string
        let str = number.toString();

        // Split the number into integer and decimal parts
        let parts = str.split(".");

        // Format integer part with commas
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        // If decimal part exists and has one digit, add a trailing zero
        if (parts[1] && parts[1].length === 1) {
            parts[1] += "0";
        }
        // Join integer and decimal parts and return
        return parts.join(".");
    }

    const addCalcNote = async () => {
        try {
            if (marginData == null)
                return;

            titleAlert("Sending to Notes... ", "update", 'calC-update');

            const note = `Cover Price: ${calCData.coverPrice}, Units: ${calCData.units}, Unit Cost: ${calCData.unitCost}, Disc: ${calCData.discount}, Ret%: ${calCData.returns}, Royalty: ${calCData.royalty}, Margin: ${marginData}`;

            const payload = {
                noteID: 0,
                isbn: props.ISBNId,
                status: "Active", isPriority: false, visibility: "Public", note: note, creator: props.upn, Action: 'I'
            };

            const res = await apiHelper.inventoryPostCall("createNotes", payload, true);

            props.setOnChangeNote();

            titleAlert("Note saved successfully", "success", 'calC-update');

        } catch (error) {
            console.error("add note  failed");
            titleAlert("Add to Note Failed.", "error", 'calC-update');
        } finally {
            setTimeout(() => titleAlert('', 'info', 'calC-update'), 2000);
        }
    }

    function onDefMarginChange(e) {
        try {
            const { name, value } = e.target;

            // const newValue = e.target.value;

            // Allow only numbers and a single decimal point
            const sanitizedValue = value.replace(/%/g, '');
            if (sanitizedValue === '' || /^[0-9]*\.?[0-9]*$/.test(sanitizedValue)) {


                /* let finalData = null;
     
                 // Allow numbers and a single decimal point
                 const data = value.replace(/[^0-9.]/g, '');
               //  const hasMultipleDots = (data.match(/\./g) || []).length > 1;
                 finalData = parseFloat(data).toFixed(2);*/

                // Only update state if there's not more than one dot and the input is valid
                //  if (finalData != undefined && finalData != null) {
                // Convert "3." to "3.0" automatically

                //   finalData = parseFloat(data).toFixed(2); // Converts to "3.0"

                // Update the default margin state
                if (sanitizedValue <= 100 && sanitizedValue >= 0) {
                    setDefaultMargin(prev => ({ ...prev, [name]: sanitizedValue }));


                    // Prepare the payload with the formatted value
                    const payload = getMarginPayLoad(false);
                    let newPayLoad = null;
                    if (sanitizedValue.endsWith('.')) {
                        //  alert();
                        return;
                    } else {
                        newPayLoad = { ...payload, [name]: (sanitizedValue != undefined && sanitizedValue != null) ? parseFloat(sanitizedValue) / 100 : null };


                        // Update the margin with the new payload
                        updateDefMargin(newPayLoad);
                    }
                    // }
                }
            }
        } catch (error) {
            console.error("on change def margin failed", error);
        }
    }



    const updateDefMargin = () => {
        clearTimeout(updatemargin.current);
        updatemargin.current = setTimeout(() => {
            const newPayLoad = getMarginPayLoad(false);
            getUpdatedMarginsRates(newPayLoad);
        }, 1500);
    }

    const handleOnKeyDown = (event) => {
        if (event?.key.toLowerCase().trim() == "enter") {
            updateDefMargin();
        }
    }
    const handleOnBlur = (event) => {
        updateDefMargin();
    }

    function getMarginPayLoad(isnew) {
        return {
            ISBN: props?.metaData?.isbn,
            discount: isnew ? null : (defaultMargin?.discount != null ? parseFloat(defaultMargin?.discount) / 100 : null),
            royaltyRate: isnew ? null : (defaultMargin?.royaltyRate != null ? parseFloat(defaultMargin?.royaltyRate) / 100 : null),
            returnsRate: isnew ? null : (defaultMargin?.returnsRate != null ? parseFloat(defaultMargin?.returnsRate) / 100 : null),
            coverPrice: isnew ? null : parseFloat(defaultMargin?.coverPrice),
        }
    }

    const getMargins = async () => {
        try {
            setIsMarginLoading(true);
            const isnew = true;
            const data = await apiHelper.inventoryPostCall("marginRates", getMarginPayLoad(isnew));
            if (data?.defaultMargin != null) {
                const newDefaultMargin = data?.defaultMargin.map(item => ({
                    royaltyRate: Math.round(item.royaltyRate * 100)?.toFixed(2),
                    discount: Math.round(item.discount * 100)?.toFixed(2),
                    returnsRate: Math.round(item.returnsRate * 100)?.toFixed(2),
                    coverPrice: item?.coverPrice?.toFixed(2)
                }));
                setDefaultMargin(newDefaultMargin[0] || null);
            } else {
                setDefaultMargin(null);
            }
            if (data?.margin != null) {

                setMarginRates(data?.margin || []);
            } else {
                setMarginRates([]);
            }
        } catch (error) {
            console.error("get marginRates failed ", error);
        } finally {
            setIsMarginLoading(false);
        }
    }

    const getUpdatedMarginsRates = async (payload) => {
        try {
            setIsMarginLoading(true);
            setIsCostLoading()

            const data = await apiHelper.inventoryPostCall("marginRates", payload);
            setMarginRates(data?.margin || []);

        } catch (error) {
            console.error("get updated marginRates failed ", error);

        } finally {
            setIsMarginLoading(false);
        }

    }
    const titleAlert = (message, className = 'info', id) => {
        try {

            const statusAlertElement = document.getElementById(id);

            statusAlertElement.textContent = message;
            statusAlertElement.className = className;

        } catch { console.error("Title alert failed"); }
    }
    const fetchData = async (id) => {
        try {
            if (id) {
                setIsCostLoading(true);
                const data = await apiHelper.inventoryPostCall("getCost", { value: id });
                if (data != undefined && data != null && data.length > 0) {
                    setRowData(data);
                } else {
                    setRowData([]);
                }
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsCostLoading(false);
        }
    }

    const showFormatDate = (dateString) => {
        if (dateString) {
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const formattedDate = `${month}/${day}/${year}`;
            return formattedDate;
        }
        return null;
    }
    const getFormatCurrentDate = () => {
        const date = new Date();
        const year = date.getFullYear();
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = monthNames[date.getMonth()];
        const day = String(date.getDate()).padStart(2, '0');
        const formattedDate = `${day}-${month}-${year}`;
        return formattedDate;
    }

    function onDefMarginChangePrice(e) {
        try {
            const { name, value } = e.target;

            // const newValue = e.target.value;

            // Allow only numbers and a single decimal point
            if (value === '' || /^[0-9]*\.?[0-9]*$/.test(value)) {


                /* let finalData = null;
     
                 // Allow numbers and a single decimal point
                 const data = value.replace(/[^0-9.]/g, '');
               //  const hasMultipleDots = (data.match(/\./g) || []).length > 1;
                 finalData = parseFloat(data).toFixed(2);*/

                // Only update state if there's not more than one dot and the input is valid
                //  if (finalData != undefined && finalData != null) {
                // Convert "3." to "3.0" automatically

                //   finalData = parseFloat(data).toFixed(2); // Converts to "3.0"

                // Update the default margin state
                setDefaultMargin(prev => ({ ...prev, [name]: value }));

                // Prepare the payload with the formatted value
                const payload = getMarginPayLoad(false);
                let newPayLoad = null;
                if (value.endsWith('.')) {
                    //  alert();
                    return;
                } else {
                    newPayLoad = { ...payload, [name]: (value != undefined && value != null) ? parseFloat(value) : null };


                    // Update the margin with the new payload
                    updateDefMargin(newPayLoad);
                }
                // }
            }
        } catch (error) {
            console.error("on change def margin failed", error);
        }
    }



    const rowClassRules = {
        // apply green to 2008
        'pale-red': (params) => { return params?.data?.latestPrinterFlag },
    };
    /*   const onGridReady = async (params) => {
           gridApi.current = params.api;
           console.info(gridApi.current);
         //  gridApi.current.autoSizeColumns(['printer']);
         //  gridApi.current.autoSizeAllColumns();
          // gridApi.current.sizeColumnsToFit();
       };*/
    const option1Action = () => {
        getMargins();
        onClose();
    }

    const handleCurrencyChange = (value, name) => {


        // Update state dynamically for each input by name
        setCalCData((prev) => ({
            ...prev,
            [name]: value || 0, // Default to 0 if value is empty
        }));
    };

    useEffect(() => {
        const denominator = (calCData.units * (1 - calCData.returns / 100) * calCData.coverPrice * (1 - calCData.discount / 100));

        if (denominator != 0) {


            let Margin =
                (
                    (calCData.units * (1 - calCData.returns / 100) * calCData.coverPrice * (1 - calCData.discount / 100))

                    - (calCData.units * calCData.unitCost)

                    - ((calCData.units * (1 - calCData.returns / 100) * calCData.coverPrice * (1 - calCData.discount / 100)) * calCData.royalty / 100)
                )
                /
                denominator
            setMarginData(parseFloat((Margin * 100).toFixed(2)));

        } else {
            setMarginData(null);
        }
    }, [calCData])

    const getUpdatedRates = useCallback((event) => {
        getUpdatedMarginsRates();
    });
    const onClose = () => {
        setShowWarning(prev => !prev);
    }
    useEffect(() => {
        if (props.metaData) {

            getMargins();
            fetchData(props.metaData.isbn);
        } else {
            setRowData([]);
        }
    }, [props.metaData]);

    return (<>
        <div className="accordion-content container-fluid specform specFormDK">
            <Form noValidate="noValidate" >

                <Row style={{ display: "flex", alignItems: "flex-start" }} >

                    {rowData && rowData.length > 0
                        ?
                        <><div className="custom mr-0 pr-0" style={{ paddingLeft: "10px", marginBottom: "20px", marginTop: "25px", marginLeft: "2px", width: "575px" }}>
                            {(isCostLoading || isMArginLoading) && <PRHLoader />}
                            <span className="SAPClass">SAP Order Numbers</span>
                            <AgGridReact
                                rowData={rowData}
                                columnDefs={columnDefsDK}
                                domLayout="autoHeight"
                                gridOptions={gridOptions}
                            />
                        </div> </>
                        :
                        <></>}
                    {props.isEditable &&
                        <div style={{
                            width: "auto", marginTop: "25px", marginLeft: rowData && rowData.length > 0 ? 'auto' : '0', marginRight: "auto", marginBottom: '20px'
                        }}>

                            <table >
                                <tr >
                                    <th colSpan="2" className="pb-1" style={{ fontSize: "16px" }}>Margin Calculator</th>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid black", padding: "3px" }}>Cover Price</td>
                                    <td style={{ border: "1px solid black", padding: "3px" }}><CurrencyInput
                                        id="input-example"
                                        style={{ border: "none", textAlign: "right" }}
                                        allowNegativeValue={false}
                                        prefix="$"
                                        name="coverPrice"
                                        placeholder="Please enter a number"
                                        defaultValue={0}
                                        decimalsLimit={2}
                                        onValueChange={handleCurrencyChange}
                                    /></td>

                                </tr>  <tr>
                                    <td style={{ border: "1px solid black", padding: "3px" }}>Units</td>
                                    <td style={{ border: "1px solid black", padding: "3px" }}><CurrencyInput
                                        id="units"
                                        style={{ border: "none", textAlign: "right" }}
                                        allowNegativeValue={false}
                                        name="units"
                                        placeholder="Please enter a number"
                                        defaultValue={0}
                                        allowDecimals={false}
                                        onValueChange={handleCurrencyChange}
                                    /></td>
                                </tr>  <tr>
                                    <td style={{ border: "1px solid black", padding: "3px" }}>Unit Cost</td>
                                    <td style={{ border: "1px solid black", padding: "3px" }}><CurrencyInput
                                        id="input-example"
                                        name="unitCost"
                                        allowNegativeValue={false}
                                        prefix="$"
                                        style={{ border: "none", textAlign: "right" }}
                                        placeholder="Please enter a number"
                                        defaultValue={0}
                                        decimalsLimit={4}
                                        onValueChange={handleCurrencyChange}
                                    /></td>
                                </tr>  <tr>
                                    <td style={{ border: "1px solid black", padding: "3px" }}>Discount</td>
                                    <td style={{ border: "1px solid black", padding: "3px" }}><CurrencyInput
                                        id="input-example"
                                        allowDecimals={false}
                                        style={{ border: "none", textAlign: "right" }}
                                        name="discount"
                                        allowNegativeValue={false}
                                        placeholder="Please enter a number"
                                        defaultValue={0}
                                        allowDecimals={false}
                                        suffix="%"
                                        onValueChange={handleCurrencyChange}
                                    /></td>
                                </tr>  <tr>
                                    <td style={{ border: "1px solid black", padding: "3px" }}>Returns %</td>
                                    <td style={{ border: "1px solid black", padding: "3px" }}><CurrencyInput
                                        id="input-example"
                                        name="returns"
                                        allowNegativeValue={false}
                                        style={{ border: "none", textAlign: "right" }}
                                        placeholder="Please enter a number"
                                        defaultValue={0}
                                        allowDecimals={false}
                                        suffix="%"
                                        onValueChange={handleCurrencyChange}
                                    /></td>
                                </tr>  <tr>
                                    <td style={{ border: "1px solid black", padding: "3px" }}>Royalty</td>
                                    <td style={{ border: "1px solid black", padding: "3px" }}><CurrencyInput
                                        id="input-example"
                                        name="royalty"
                                        allowNegativeValue={false}
                                        style={{ border: "none", textAlign: "right" }}
                                        placeholder="Please enter a number"
                                        defaultValue={0}
                                        decimalsLimit={2}
                                        suffix="%"
                                        onValueChange={handleCurrencyChange}
                                    /></td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid black", padding: "3px", fontWeight: "700" }}>Margin %</td>
                                    <td style={{ border: "1px solid black", padding: "3px", textAlign: "right", fontWeight: "700" }}>
                                        {marginData ? `${marginData}%` : ""}
                                    </td>
                                    <td style={{ padding: "3px" }}>    <button type="button"
                                        className={'ISBNSubmit width100'}
                                        onClick={() => addCalcNote()}
                                        disabled={!marginData}>Add to Notes</button>
                                    </td>
                                </tr>
                                <tr><span id="calC-update"></span></tr>
                            </table>
                        </div>}

                </Row>
                {defaultMargin != null
                    ?
                    <>
                        <div className="custom m-0 p-0 noFlexWrap width380" >
                            <span className="m-0 p-0 d-flex justify-content-between">
                                <span onClick={() => setActiveAltRates(prev => !prev)} className={activeAltRates ? 'drpLabelActive' : 'drpLabel'}>Alt Rates</span>
                                <button type="button"
                                    className={props.isEditable ? 'ISBNSubmit btn-smSource2 width100' : 'btn-smSource2 width100'}
                                    disabled={!props.isEditable}
                                    hidden={!activeAltRates}
                                    onClick={() => onClose()}>Reset to default</button>
                            </span>
                            <div className={activeAltRates ? 'showdata' : 'hideData'}>
                                <table className="tableMargin mb-4 alt-table">
                                    <thead>
                                    <tr>
                                        <th style={{ textAlign: "right"}}>Alt Royalty Rate</th>
                                        <th style={{ textAlign: "right"}}>Alt Discount</th>
                                        <th style={{ textAlign: "right"}}>Alt Returns Rate</th>
                                        <th style={{ textAlign: "right"}}>Alt Edition Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><input style={{ borderRight: 'none', textAlign: "right" }} value={defaultMargin?.royaltyRate != null ? `${defaultMargin.royaltyRate}%` : ""} name="royaltyRate" onChange={onDefMarginChange} onKeyDown={handleOnKeyDown} onBlur={handleOnBlur}></input></td>
                                            <td><input style={{ borderRight: 'none', textAlign: "right" }} value={defaultMargin?.discount != null ? `${defaultMargin.discount}%` : ""} name="discount" onChange={onDefMarginChange} onKeyDown={handleOnKeyDown} onBlur={handleOnBlur}></input></td>
                                            <td><input style={{ borderRight: 'none', textAlign: "right"}} value={defaultMargin?.returnsRate != null ? `${defaultMargin.returnsRate}%` : ""} name="returnsRate" onChange={onDefMarginChange} onKeyDown={handleOnKeyDown} onBlur={handleOnBlur}></input></td>
                                            <td><input value={defaultMargin?.coverPrice != null ? defaultMargin.coverPrice : ""} name="coverPrice" onChange={onDefMarginChangePrice} onKeyDown={handleOnKeyDown} onBlur={handleOnBlur} style={{ textAlign: "right" }}></input></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>


                        <div className="m-0 p-0" style={{ width: "auto" }}>
                            <span style={{ width: "100px" }} className={`SAPClass ${activeMarginRates ? 'drpLabelActive mr-4' : 'drpLabel mr-4'}`} onClick={() => setActiveMarginRates(prev => !prev)}> Printer Scales</span> <span id="margin-update"></span>
                            <div className={`${activeMarginRates ? 'showdata' : 'hideData'}`} style={{ overflow: "auto", maxheight: "150px" }}>
                                <table className="tableMargin" style={{ borderCollapse: "collapse" }}>
                                    <thead style={{ position: "sticky", top: 0, zIndex: 1, borderLeft: "1px solid black" }}>
                                        <tr>
                                            {columnDefMarginRates.map((col, index) => (
                                                <th
                                                    key={index}
                                                    style={{ width: `${col.width}px` }}
                                                    className={col.headerClass || ''}
                                                >
                                                    {col.headerName}
                                                </th>
                                            ))}
                                            <th style={{ backgroundColor: "white", position: "sticky", borderLeft: "1px solid black" }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {marginRates.map((row, rowIndex) => (
                                            <tr key={rowIndex} style={{
                                                backgroundColor: row.latestPrinterFlag ? '#ffb6c1' : ''
                                            }}>
                                                {columnDefMarginRates.map((col, colIndex) => (
                                                    <td
                                                        key={colIndex}
                                                        style={{ border: "1px solid black" }}
                                                        className={col.cellClass || ''}
                                                    >
                                                        {col.cellRenderer
                                                            ? col.cellRenderer({ data: row[col.field] })
                                                            : col.valueFormatter
                                                                ? col.valueFormatter({ value: row[col.field] })
                                                                : row[col.field]}
                                                    </td>
                                                ))}
                                                <td style={{ backgroundColor:"white" }}>
                                                    <button type="button"
                                                        className='ISBNSubmit btn-smSource2'
                                                        disabled={!props.isEditable}
                                                        onClick={() => sendNotes(row)}>Send to Note</button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </>
                    :
                    <></>}
            </Form>

            {showWarning && <GeneralWarningPopUp onClose={onClose} option1Action={option1Action} warning={warning} title={title} option1={option1} option2={option2} />}
        </div>

    </>)
}